import { render, staticRenderFns } from "./addModule.vue?vue&type=template&id=5abc7beb&scoped=true&"
import script from "./addModule.vue?vue&type=script&lang=js&"
export * from "./addModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abc7beb",
  null
  
)

export default component.exports